var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptedDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 28C14.0687 28 22.2661 28 22.9064 28C23.7067 28 25.3074 27.611 26.1077 25.666C26.908 23.7211 28.5086 19.8312 29.7091 16.7192C30.9096 13.6073 28.1085 11.6623 26.5078 11.6623C25.2273 11.6623 21.9727 11.6623 20.5054 11.6623C20.5054 10.7547 20.5054 7.51399 20.5054 5.95802C20.5054 2.47791 16.875 2.08999 15.825 4.68101C14.5629 7.79538 12.675 12.4403 9 12.4403",
    stroke: "#9FA6AD",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 6,
    height: 20,
    rx: 1,
    stroke: "#9FA6AD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedDark);
export default __webpack_public_path__ + "static/media/acceptedDark.41c91f2435745acdd4ef3e0f88f4f4a2.svg";
export { ForwardRef as ReactComponent };